import { ArrowRight, Sprout } from 'lucide-react';
import Reveal from './Reveal';

export const Expansion = () => (
  <section data-testid="expansion-section" className="pb-24 sm:pb-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] border-2 border-dashed border-sage bg-sage-mist px-8 py-14 text-center sm:px-14">
          <Sprout className="mx-auto h-8 w-8 text-forest" />
          <p className="mt-5 text-xs font-bold uppercase tracking-[0.3em] text-gold">What&apos;s Next</p>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-medium leading-tight tracking-tight text-ink sm:text-4xl">
            More agricultural export products <span className="accent-italic font-semibold">coming soon.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base">
            Our portfolio will expand in line with buyer demand. If you are sourcing a specific agricultural product
            from India, tell us — we may already be working on it.
          </p>
          <a
            href="#contact"
            data-testid="expansion-cta-btn"
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-forest px-7 py-3.5 text-sm font-bold text-cream shadow-soft transition-all duration-300 hover:-translate-y-0.5 hover:bg-forest-deep hover:shadow-lift"
          >
            Tell Us What You Need
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Expansion;
